import styled from 'styled-components'
import { CartIcon } from '@shipt/design-system-icons'
import { Indicator } from '@/features/shared/components/NotificationBadge'
import { Column } from '@shipt/design-system-layouts'
import { Body } from '@shipt/design-system-typography'

type Props = { showIndicator: boolean }

export const DummyCartIcon = ({ showIndicator }: Props) => (
  <Column align="center">
    <BadgeWrapper>
      <CartIcon />
      {!!showIndicator && (
        <Indicator data-corner="right" value={1} as="span">
          1
        </Indicator>
      )}
    </BadgeWrapper>
    <Body size="sm">Cart</Body>
  </Column>
)

const BadgeWrapper = styled.div`
  position: relative;
  display: inline-block;
`
